import { defineAsyncComponent, ref } from 'vue'

// 动态组件
const component = {
  // 联合处方
  prescriptionGroup: {
    name: '处方详情',
    is: defineAsyncComponent(() => import('../Prescription/Group/index.vue'))
  },
  prescriptionOnline: {
    name: '线上处方详情',
    is: defineAsyncComponent(() => import('../Prescription/Online/index.vue'))
  },
  prescriptionHealth: {
    name: '健康辅助方',
    is: defineAsyncComponent(() => import('../Prescription/Health/index.vue'))
  },
  prescriptionOffline: {
    name: '线下处方详情',
    is: defineAsyncComponent(() => import('../Prescription/Offline/index.vue'))
  },
  visit: {
    name: '随访计划详情',
    is: defineAsyncComponent(() => import('../Visit/index.vue'))
  },
  check: {
    name: '检查单详情',
    is: defineAsyncComponent(() => import('@/views/HealthRecord/checklistDetail.vue'))
  },
  gauge: {
    name: '随访量表',
    is: defineAsyncComponent(() => import('../Gauge/index.vue'))
  },
  onLineRecord: {
    name: '线上病历详情',
    is: defineAsyncComponent(() => import('../MedicalRecord/index.vue'))
  },
  offLineRecord: {
    name: '门诊病历详情',
    is: defineAsyncComponent(() => import('../MedicalRecord/index.vue'))
  }
}
export default function (props = {}) {
  // 当前活动的组件
  const activeKey = ref('')
  // 当前有几个详情跳转（目前只有3个）
  const details = ref([])
  // 重置数据
  function resetActive() {
    details.value.splice(0)
    activeKey.value = ''
  }
  /**
   * @description: 添加 aliveDetail
   * @param {String} is 组件明
   * @param {Number|String} id 详情id
   * @param {String} serialNumber 详情编号
   * @return {Boolean} 成功失败
   */
  function addDetail(is, id = '', serialNumber = '') {
    // 有相同的不能添加
    if (details.value.some(v => v.id === id && v.serialNumber === serialNumber)) return
    details.value.push({
      name: component[is].name,
      is: is,
      id: id,
      serialNumber: serialNumber,
      key: `${is}-${id}-${serialNumber}`,
      mode: props.mode || ''
    })
  }
  /**
   * @description: 跳转到组件中有的组件中
   * @param {String} is 组件名称
   * @param {number} id 详情id
   * @param {String} serialNumber 详情编号
   * @param {Object} ext 拓展信息
   * NOTE:量表 survey.id=id survey.sendId=serialNumber
   */
  function jumpTo(is, id = '', serialNumber = '') {
    if (!is) return
    // DEBUG:im传过来数字类型 详情里面又是字符串 统一字符串(确保唯一)
    id += ''
    serialNumber += ''
    activeKey.value = `${is}-${id}-${serialNumber}`
    addDetail(is, id, serialNumber)
  }
  /**
   * NOTE:必须当前详情至少有2条，否者不能删除
   * @description:移除指定某一个详情，跳转到目前第一个
   * @param {Number|String} id id
   * @param {String} serialNumber 编号
   */
  function removeOneDetail(_id, _serialNumber) {
    const _index = details.value.findIndex(v => v.id === _id && v.serialNumber === _serialNumber)
    // 必须当前详情至少有2条
    const lenGTTwo = details.value.length > 1
    lenGTTwo && !!~_index && details.value.splice(_index, 1)
    const { is, id, serialNumber } = details.value[0]
    jumpTo(is, id, serialNumber)
  }
  return {
    component,
    activeKey,
    details,
    jumpTo,
    resetActive,
    removeOneDetail
  }
}
